import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { BodyClassService } from 'src/app/providers/util/BodyClassService';

/**
 * IQAC Footer Component
 *
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use `<app-enhanced-fab>` directly instead, which provides the same interface with enhanced features.
 *
 * Migration guide:
 * Replace `<app-iqac-froms-footer>` with `<app-enhanced-fab>` in your templates.
 * The inputs and outputs remain the same:
 * - [pageSpecificFormObject]
 * - [webCoCanSubmit]
 * - (footerEmitter)
 *
 * The Enhanced FAB component automatically handles:
 * - Action generation based on user roles and form status
 * - IQAC subsection logic (ID 31) integrated in FABIntegrationService
 * - All validation and alert dialogs
 * - Smart primary action selection
 * - Mobile-optimized interaction patterns
 *
 * ========================================================================
 * ORIGINAL LOGIC PRESERVED BELOW FOR REFERENCE
 * ========================================================================
 */
@Component({
	selector: 'app-iqac-froms-footer',
	standalone: false,
	templateUrl: './iqac-froms-footer.component.html',
	styleUrls: ['./iqac-froms-footer.component.scss']
})
export class IqacFromsFooterComponent implements OnInit {
	@Input() pageSpecificFormObject;
	@Input() webCoCanSubmit: boolean;
	@Output() footerEmitter: EventEmitter<any> = new EventEmitter<any>();

	bottomSheetOpen$: boolean = false;

	isIQACADMIN: boolean = false;
	isWEBEQUI: boolean = false;
	loggedInUserName: any;
	constructor(public userdataService: UserDataService, private bodyClassService: BodyClassService) {}

	ngOnInit() {
		this.bodyClassService.hasClass('bottom-sheet-open').subscribe((data) => {
			this.bottomSheetOpen$ = data;
		});
		this.checkLoggedInUserRole();
		this.getUserInfo();
	}

	checkLoggedInUserRole() {
		this.userdataService.getLoggedInUserRole().then((roles) => {
			if (roles) {
				if (roles.includes('IQAC_ADMIN')) {
					this.isIQACADMIN = true;
				}
				if (roles.includes('WEB_EQUI')) {
					this.isWEBEQUI = true;
				}
			}
		});
	}
	getUserInfo() {
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.loggedInUserName = profile.emailId;
			}
		});
	}

	sendFormForApproval() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('sendFormForApproval');
		}
	}
	rejectForm() {
		this.footerEmitter.emit('rejectForm');
	}
	forwordForm() {
		this.footerEmitter.emit('forwordForm');
	}
	formSharing() {
		this.footerEmitter.emit('formSharing');
	}
	recallForm() {
		this.footerEmitter.emit('recallForm');
	}
	resentForm() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('resentForm');
		}
	}
	replicateForm() {
		this.footerEmitter.emit('replicateForm');
	}
	submitForm() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('submitForm');
		}
	}
	updateForm() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('updateForm');
		}
	}
	approvedForm() {
		this.footerEmitter.emit('approvedForm');
	}
	submitForApprovalWebC() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('submitForApprovalWebC');
		}
	}
	deleteForm() {
		this.footerEmitter.emit('deleteForm');
	}
	canSubmit(): boolean {
		return (
			this.isIQACADMIN &&
			this.isIQACSubsection() &&
			(this.pageSpecificFormObject.status == 'CREATED' ||
				this.pageSpecificFormObject.status == 'RECALLED' ||
				this.pageSpecificFormObject.status == 'REVERTED' ||
				this.pageSpecificFormObject.status == 'RESENT')
		);
	}

	isIQACSubsection(): boolean {
		var result =
			this.pageSpecificFormObject.formTypeDTO !== undefined &&
			this.pageSpecificFormObject.formTypeDTO.fomSubSection !== undefined &&
			this.pageSpecificFormObject.formTypeDTO.fomSubSection.id !== undefined &&
			this.pageSpecificFormObject.formTypeDTO.fomSubSection.id === 31;
		return result;
	}

	canReject(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		let result =
			formStatus === 'SUBMITTED_FOR_APPROVAL' ||
			formStatus === 'APPROVED' ||
			formStatus === 'APPROVED_WITH_WebC' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
			formStatus === 'SHARED_WITH_WEB_AND_OFFICE' ||
			formStatus === 'SHARED_WITH_WebC' ||
			formStatus === 'SHARED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE';
		return this.isIQACADMIN && result;
	}
	canForward(): boolean {
		return (
			this.isIQACADMIN &&
			(this.pageSpecificFormObject.status == 'APPROVED' ||
				this.pageSpecificFormObject.status === 'APPROVED_WITH_WebC' ||
				this.pageSpecificFormObject.status === 'APPROVED_WITH_OFFICE_CO')
		);
	}
	canAprove(): boolean {
		return this.isIQACADMIN && this.pageSpecificFormObject.status == 'SUBMITTED_FOR_APPROVAL';
	}
	canUpdate(): boolean {
		return (
			this.pageSpecificFormObject.id &&
			this.isIQACADMIN &&
			(this.pageSpecificFormObject.status == 'CREATED' ||
				this.pageSpecificFormObject.status == 'REVERTED' ||
				this.pageSpecificFormObject.status == 'RECALLED' ||
				this.pageSpecificFormObject.status == 'RESENT')
		);
	}
	canSubmitByWebc(): boolean {
		return this.isWEBEQUI && this.pageSpecificFormObject.status == 'SHARED_WITH_WebC' && this.webCoCanSubmit;
	}
	canReplicate(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		let statuscheck =
			formStatus === 'APPROVED' ||
			formStatus === 'APPROVED_WITH_WebC' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE' ||
			formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED';
		return this.isIQACADMIN && statuscheck && this.loggedInUserName == this.pageSpecificFormObject.createdBy;
	}
	canCreate(): boolean {
		return this.isIQACADMIN && this.pageSpecificFormObject.id == null;
	}

	canRecall(): boolean {
		return (
			this.isIQACADMIN &&
			this.pageSpecificFormObject.status == 'SHARED' &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy
		);
	}

	canResent(): boolean {
		return (
			!this.isIQACADMIN &&
			this.pageSpecificFormObject.status == 'SHARED' &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName != this.pageSpecificFormObject.createdBy
		);
	}

	canDeleteForm(): boolean {
		return (
			this.pageSpecificFormObject.createdBy == this.loggedInUserName && this.pageSpecificFormObject.status == 'CREATED'
		);
	}

	titleValidationCheck() {
		let titleCheck = true;
		if (this.pageSpecificFormObject.title === undefined) {
			this.userdataService.presentToast('Please Enter Title', 'danger');
			titleCheck = false;
		} else if (this.pageSpecificFormObject.title.trim().length === 0) {
			this.userdataService.presentToast('Please Enter Title', 'danger');
			titleCheck = false;
		}
		return titleCheck;
	}
}
